/**
 * Translation context and hook.
 *
 * Kept apart from the provider component so a hot reload of the provider never
 * re-creates the context out from under mounted components.
 */
import { createContext, use } from 'react';

import { ErrorFactories, type Locale, type MessageKey, type MessageParams, type MessageRef } from '@daka/core';

/** Either a bare key or a full ref, so call sites stay short. */
type Translatable = MessageKey | MessageRef;

export interface I18nValue {
   /** The locale of the catalogue in use — copy and formats alike. */
   readonly locale: Locale;
   readonly t: (value: Translatable, params?: MessageParams) => string;
}

export const I18nContext = createContext<I18nValue | null>(null);

/** The translate function. A missing provider is a wiring bug, not a user-facing condition. */
export function useT(): I18nValue['t'] {
   const value = use(I18nContext);
   if (!value) throw ErrorFactories.internal();
   return value.t;
}
